import cn from 'classnames';
import React from 'react';
import IconRating from '../../assets/icons/rating.svg';

interface PropTypes {
  max?: number;
  value: number;
  color?: string;
  width?: string;
  className?: string;
}

const Rating: React.FC<PropTypes> = ({
  max = 5,
  value = 0,
  className,
  width = 'w-12',
  color = 'text-primary-main',
}) => (
  <div className={cn('relative', className)}>
    <IconRating className={cn(width, 'text-grey-100 h-full')} />
    <div
      className="absolute top-0 left-0 h-full overflow-hidden"
      style={{ width: `${(value / max) * 100}%` }}
    >
      <IconRating className={cn(width, 'h-full', color)} />
    </div>
  </div>
);

export default Rating;
